// extracted by mini-css-extract-plugin
module.exports = {"box":"business-resource-download-grid_box__GnUTk","downloadButton":"business-resource-download-grid_downloadButton__zAuQP"};